<template>
  <img
    class="object-contain w-full"
    :class="[
      $attrs.class ? $attrs.class : 'h-10'
    ]"
    alt="GoBiz logo"
    src="@/assets/image/logo-gobiz.svg"
  />
</template>